import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  TemplateRef,
  ViewChild,
  OnDestroy,
} from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";

import { GSFReport } from "../GSF-report.service";
import { CONSTANTS } from "../constants/pillar.const";

import { ActivityDependencyService } from "../service/activity-dependency.service";
import { CommonActivityService } from "../service/common-activity.service";
import { ReportCalculateService } from "../service/report-calculate.service";
import { ReportDataService } from "../service/report-data.service";
import { WasteReductionService } from "../wasteReduction/service/waste-reduction.service";
import {
  DialogContentComponent,
  DialogContentMetadata,
  DialogType,
} from "../dialog-content/dialog-content.component";
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from "@angular/material/legacy-dialog";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { PillarRouteState } from "../models";
import { Subscription } from "rxjs";
import { TitleCasePipe } from "@angular/common";

@Component({
  selector: "app-pillar",
  templateUrl: "./pillar.component.html",
  styleUrls: ["./pillar.component.css"],
})
export class PillarComponent implements OnInit, OnDestroy {
  @ViewChild("messagePopupTemplate")
  messagePopupTemplateRef: TemplateRef<DialogContentComponent>;

  pillar: any;
  pillarForm: UntypedFormGroup;
  @Input()
  reportSubmissionId: number;

  @Input()
  reportId: number;

  @Input()
  pillarName;

  @Input()
  Language: string;

  @Input()
  name: string;

  @Output()
  modifiedActivity: EventEmitter<number> = new EventEmitter();
  counter = 0;
  clasHelpDialog = false;
  reportHasNegativeOrZero = false;
  errorMsg: string;
  OKmsg: string;
  @Input()
  previousSelectedTab: number;
  @Output()
  errorInChildPillarComp: EventEmitter<string> = new EventEmitter();
  @Output()
  callTabChange: EventEmitter<string> = new EventEmitter();
  @Input()
  dbCallFlag: any;
  resetDialog = false;
  isMoveToOverViewClicked = false;
  isBackToCdpClicked = false;
  hasComActList: any = [];
  commonActivityMapConfig;
  @Input() isViewMode?: boolean = false;

  @Input() reportYear?: number = null;
  @Input() public entryId?: number = null;
  private dialogRef: MatDialogRef<DialogContentComponent>;
  public dialogContentMetadata: DialogContentMetadata = null;
  private readonly routerState: PillarRouteState;

  private formatedPillars: PillarRouteState[] = [];
  private subscribe: Subscription = null;

  constructor( //nosonar
    public activityDependency: ActivityDependencyService,
    public commActService: CommonActivityService,
    public report: GSFReport,
    public translate: TranslateService,
    public wasteRedService: WasteReductionService,
    private readonly calService: ReportCalculateService,
    private readonly reportDataService: ReportDataService,
    public readonly dialog: MatDialog,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly titleCase : TitleCasePipe
  ) {
    this.translate = translate;
    translate.setDefaultLang(CONSTANTS.ENG);
    if (
      this.router.getCurrentNavigation() &&
      this.router.getCurrentNavigation().extras &&
      this.router.getCurrentNavigation().extras.state
    ) {
      const temp = this.router.getCurrentNavigation().extras.state;
      console.log(temp);
    }
  }

  ngOnInit() {
    this.subscribe = this.route.paramMap.subscribe((params: ParamMap) => {
      this.pillar=null;

      this.formatedPillars = this.report.getFormatedPillars();
      this.pillarName = params.get("pillarName");

      this.initialize();
    });
  }

  onFormChange() { 
    this.pillarForm.valueChanges.subscribe(value => { //nosonar
      this.pillar.activities.forEach((activity,activityIndex) => {
        activity["DuplicateEntryField3"] = false;
        activity["DuplicateEntryField4"] = false;
        activity["errorsField"] = {
          flag: false,
        };
        if(activity["hasFieldDependency"] === true && value.activitiesFormGroup[activityIndex] 
        && value.activitiesFormGroup[activityIndex].toggleFlagCtl){
          const activityId = activity.id;
          const dep = this.activityDependency.dependency[activityId];
          const questionList = value.activitiesFormGroup[activityIndex].questionList;

          questionList.forEach((ql, qnIndex) => {
            if (activity.questionList[qnIndex].status !== CONSTANTS.DELETE) {
              const inputs = ql.inputList;
              let self = dep.self;
              inputs.forEach((ip, i) => {
                if(ip) {
                  self = (self ?? '').replace(`$#${i}$#`, ip ? this.titleCase.transform(ip.toString()) : ip)
                }
              })
              const depIdsList = dep.dependedFieldActivityList;
                depIdsList.forEach((actId) => {
                const crossActivityIndex = this.pillar.activities.findIndex(act => act.id === actId);
                const crossQuestionList = value.activitiesFormGroup[crossActivityIndex].questionList;
                const cA = this.pillar.activities[crossActivityIndex]
                if (value.activitiesFormGroup[crossActivityIndex].toggleFlagCtl) {
                  crossQuestionList.forEach((cql, cqlIndex) => {
                    if (cA.questionList[cqlIndex].status !== CONSTANTS.DELETE) {
                      const crossInputs = cql.inputList;
                      let crossDep = dep[actId];
                      console.log("CrossDep", crossDep)
                      crossInputs.forEach((ip, j) => {
                        if(ip) {
                          crossDep = (crossDep ?? '').replace(`$#${j}$#`, ip ? this.titleCase.transform(ip.toString()) : ip)
                        }
                      })
                      if (crossDep === self) {
                        
                        if ((activityId === "AGS1" && cA.id === "AG.1") || (activityId === "AG.1" && cA.id === "AGS1")) {
                          
                          activity["DuplicateEntryField4"] = true;
                        } else if (activityId === "NAT.4" && cA.id === "DF.5" || activityId === "DF.5" && cA.id === "NAT.4") {
                          
                          activity["DuplicateEntryField3"] = true;
                        }
                        if (!activity["duplicateWarningOnly"]) {
                          activity["errorsField"] = {
                            flag: true,
                            msg: "Field level validation errors"
                          };
                        }
                      }
                    }
                  })
                }
              })
            }
          })
        }
      })
    })
  }

  initialize() {
    if (this.commActService.commonActivityMap) {
      this.commonActivityMapConfig = JSON.parse(
        JSON.stringify(this.commActService.commonActivityMap)
      );
    }

    if (this.Language) {
      this.translate.use(this.Language);
    }

    this.calService
      .getPillarQuestions(this.pillarName,this.reportDataService.Language, this.reportYear)
      .subscribe((qusConfigJson) => {
        this.pillar = qusConfigJson;
        if (this.pillar.havingTableActivity) {
          this.wasteRedService.loadWasteReductionData(this.Language);
        }

        this.pillarForm = this.report.createPillarFormGroup(this.pillar);
        this.onFormChange();
      });

    this.report.dbCallFlag = this.dbCallFlag;
  }

  getMatCardBgColor(activityInd) {
    const activity = this.pillar.activities[activityInd];
    if (
      activity.commonActivity &&
      this.commActService &&
      this.commActService.commonActivityMap &&
      this.commActService.commonActivityMap[activity.id] &&
      !this.commActService.commonActivityMap[activity.id][this.pillarName]
        .hasAllowToAnswer
    ) {
      return CONSTANTS.COLORHEX;
    }
    if (this.pillar.activities[activityInd].hasDependency) {
      const hasAllowToAnswer = this.activityDependency.hasAllowToAnswer(
        activity.id
      );
      if (!hasAllowToAnswer) {
        return CONSTANTS.COLORHEX;
      } else if (this.pillar.activities[activityInd].toggleFlag) {
        return CONSTANTS.COLORWHITE;
      } else {
        return CONSTANTS.WHITE;
      }
    } else if (this.pillar.activities[activityInd].toggleFlag) {
      return CONSTANTS.COLORWHITE;
    } else {
      return CONSTANTS.WHITE;
    }
  }

  getMatCardColor(activityInd) {
    if (
      (this.pillar.activities[activityInd].duplicateEntryFlag && !this.pillar.activities[activityInd].duplicateWarningOnly) ||
      this.getHasErrorsCond(activityInd)
    ) {
      return CONSTANTS.SOLIDRED;
    } else if (this.pillar.activities[activityInd].toggleFlag) {
      if(this.pillar.activities[activityInd].duplicateWarningOnly){
        return CONSTANTS.SOLIDORANGE;
      }
      return CONSTANTS.SOLIDGREEN;
    } else {
      return CONSTANTS.SOLIDORANGE;
    }
  }

  private getHasErrorsCond(activityInd) {
    return (
      this.pillar.activities[activityInd].errors &&
      this.pillar.activities[activityInd].errors.flag
    );
  }

  previousTab() {
    const temp = this.formatedPillars.find(
      (obj) => obj.name === this.pillarName
    );

    const previousPillar = this.formatedPillars.find(
      (obj) => obj.name === temp.previousPillarName
    );
    if (previousPillar) {
      this.router.navigate(["../", previousPillar.name], {
        relativeTo: this.route,
        state: { data: previousPillar, formatedPillars: this.formatedPillars },
      });
    }

    window.scrollTo(0, 0);
  }

  nextTab() {
    const temp = this.formatedPillars.find(
      (obj) => obj.name === this.pillarName
    );
    const nextPillar = this.formatedPillars.find(
      (obj) => obj.name === temp.nextPillarName
    );
    if (nextPillar) {
      this.router.navigate(["../", nextPillar.name], {
        relativeTo: this.route
      });
    }
    window.scrollTo(0, 0);
  }

  onModified(e) {
    this.modifiedActivity.emit(e);
  }

  errorInActivity(errorFlag) {
    this.errorInChildPillarComp.emit(errorFlag);
  }

  getHelpLink(activity) {
    activity.showHelpLink = true;
  }

  closeHelpDialog(activity) {
    activity.showHelpLink = false;
  }

  updateCommonPillar() {
    this.commActService.commPillarHasToReload[this.pillar.name] = false;
    this.ngOnInit();
  }

  public showTooltipPopUp(activities): void {
    this.dialogContentMetadata = {
      heading: "",
      subHeading: activities.tooltip,
      primaryButtonText: "OK",
      type: DialogType.Message,
      imageUrl: "assets/images/Illustration_Popup.png",
    };

    this.openPopUp();
  }

  public openPopUp(): void {
    this.dialogRef = this.dialog.open(this.messagePopupTemplateRef, {
      width: "600px",
      autoFocus: false,
      disableClose: true,
    });
  }

  onMessageDialogClose(event) {
    if (event) {
      this.dialogRef.close();
    }
  }

  ngOnDestroy(): void {
    this.subscribe.unsubscribe();
  }
}
